module.exports = __webpack_public_path__ + "static/media/lingshou.f5869368.jpg";